import React from 'react';
import { Provider as AulaNextThemeProvider } from '@ublend-npm/aulaui-next';
import { QueryProvider } from './QueryClientProvider';

export const Providers = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <QueryProvider>
    <AulaNextThemeProvider>{children}</AulaNextThemeProvider>
  </QueryProvider>
);
